import * as React from 'react';
import {useForm} from 'react-hook-form';
import {StyleSheet, Text, View} from 'react-native';
import {globalFontStyle, globalStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import {Button} from '../../../components/core/Button';
import {Input} from '../../../components/core/Input';
import LottieComp from '../../../commonComponents/Lottie';
import {RegEx} from '../../../utils/commonMethods';
import {kyc_progress, order_failed} from '../../../utils/images';
import {Network} from '../../../utils/network';
import {useToast} from '../../../components/core/Toast';
import {useDispatch} from 'react-redux';
import {getBankDetails} from '../../Profile/redux/profile.action';
import {globalImport} from "../../../common/globalImports";

const bankStatus = [
  {
    id: 1,
    title: 'Bank Verification Failed',
    lottie: order_failed,
    buttonName: 'Retry',
  },
  {
    id: 2,
    title: 'Bank Verification Under Processing',
    lottie: kyc_progress,
    buttonName: 'Done',
  },
];

const BankChange = ({initiateBottomSheetClose}) => {
  const {
    control,
    formState: {errors, isValid, isSubmitting},
    handleSubmit,
    reset,
    watch,
  } = useForm({mode: 'onChange'});
  const dispatch = useDispatch();
  const [respError, setResponseError] = React.useState();
  const [selectedErrorId, setSelectedErrorId] = React.useState();
  let selectedBankStatus = bankStatus[selectedErrorId];
  const accountNumber = watch('accountNumber');
  const accountNumberCheck = watch('accountNumberCheck');
  const {toast} = useToast();

  const onClickBankUpdate = async (details, e) => {
    e.preventDefault();

    const data = {
      accountNumber: details.accountNumberCheck,
      ifsc: details.ifsc,
    };

    const res = await Network.addNewBank(data, true);
    if (!res?.data?.success) {
      if (res?.data?.status && res?.data?.status === 'Pending') {
        setSelectedErrorId(1);
      } else {
        setSelectedErrorId(0);
      }
      setResponseError(res?.data?.error);
    } else {
      initiateBottomSheetClose();
      toast({
        title: 'Your bank details added successfully!',
        variant: 'info'
      });
    }
  };

  const onErrorBtnClick = () => {
    dispatch(getBankDetails());
    setResponseError(false);
    if (selectedBankStatus.id === 2) {
      initiateBottomSheetClose();
    }
  };

  return (
    <>
      {!respError ? (
        <View style={{paddingHorizontal: 17, paddingVertical: 17}}>
          <Text style={styles.addBankNote}>
            Mismatch in name on PAN and Bank Account details will lead to
            unsuccessful verification. Please cross-check details before
            submitting
          </Text>

          <Input
            name="ifsc"
            control={control}
            label="IFSC CODE"
            variant="default"
            size="default"
            placeholder="Write IFSC Code here"
            formatter="ifsc"
            rules={{
              required: 'Please enter IFSC code',
              pattern: {
                value: RegEx.ifsc,
                message: 'Please enter a valid IFSC',
              },
            }}
          />

          <View style={{marginTop: 25}}>
            <Input
              name="accountNumber"
              control={control}
              label="ACCOUNT NO"
              variant="default"
              size="default"
              placeholder="Please enter a valid Account Number"
              numeric={true}
              rules={{
                required: 'Please enter account number',
                pattern: {
                  value: RegEx.accountNum,
                  message: 'Please enter a valid Account Number',
                },
              }}
            />
          </View>

          <View style={{marginTop: 25}}>
            <Input
              name="accountNumberCheck"
              control={control}
              label="CONFIRM ACCOUNT NO"
              variant={accountNumberCheck !== accountNumber ? "error" : "default"}
              size="default"
              placeholder="Re-enter Account Number"
              numeric={true}
              rules={{
                required: true,
                validate: {
                  equal: value => value === accountNumber || "The account numbers don't match",
                },
              }}
            />
          </View>

          <Text style={styles.addBankNote1}>
            Please make sure that your bank details are matching with your KYC
            details for a hassel-free withdrawal process. We'll deposit 1 in
            order to verify your bank account.
          </Text>

          <Button
            variant={!isValid ? "disabled" : "primary"}
            onPress={handleSubmit(onClickBankUpdate)}
            style={{flex: globalImport.isWeb ? {} : 0, marginTop: 15}}
            disabled={!isValid}
          >
            Confirm Request
          </Button>
        </View>
      ) : (
        <View style={{paddingHorizontal: 17, paddingVertical: 17}}>
          <LottieComp
            lottieJson={selectedBankStatus.lottie}
            width={200}
            height={200}
          />
          <Text style={styles.errTitle}>{selectedBankStatus.title}</Text>
          <Text style={styles.errSubtitle}>{respError}</Text>
          <Text style={styles.errNote}>
            Please make sure that your bank details are matching with your KYC
            details. If issue still persists please drop us mail on
            help@tradexapp.co
          </Text>
          <Button
            variant={selectedBankStatus.id === 1 ? "error" : "warning"}
            onPress={onErrorBtnClick}
            style={{flex: globalImport.isWeb ? {} : 0, marginTop: 15}}
          >
            {selectedBankStatus.buttonName}
          </Button>
        </View>
      )}
    </>
  );
};

export default BankChange;

const styles = StyleSheet.create({
  addBankNote: {
    ...globalFontStyle.appFontSmallTextBold,
    color: Colors.black,
    marginBottom: 30,
  },
  addBankNote1: {
    ...globalFontStyle.appSmall10,
    color: Colors.tradexBlue,
    textAlign: 'center',
    marginTop: 30,
  },
  errTitle: {
    ...globalFontStyle.appFontSubHeading,
    color: Colors.black,
    textAlign: 'center',
  },
  errNote: {
    ...globalFontStyle.appSmall10,
    color: Colors.black,
    textAlign: 'center',
  },
  errSubtitle: {
    ...globalFontStyle.appFontSmallText,
    color: Colors.black,
    marginBottom: 40,
    textAlign: 'center',
  },
});
